module.exports = __webpack_public_path__ + "static/scale-model-of-mork-and-mindy-house-in-boulder-colorado-008e4a4d6b614eb6234f220d6a1983a4.png";